import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const EsignUploadPdfViaLinkInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-cloud-upload', title: 'E-Sign Upload PDF via Link', subtitle: 'Attach a PDF to an e-sign request via a public URL' }}
        fields={[
            { name: 'clientId', label: 'Client ID', icon: 'pi-key', placeholder: 'esign_xxxxxxxxxxxxx', maxLength: 100, mono: true },
            { name: 'link', label: 'PDF URL', icon: 'pi-link', placeholder: 'https://example.com/document.pdf', maxLength: 500, autoCapitalize: 'none', spellCheck: false,
              regex: /^https?:\/\/.+/, regexError: 'Enter a valid URL (http:// or https://)' },
        ]}
        endpoint={{
            path: '/surepass/esign/upload-pdf-via-link',
            bodyMapper: (v, sid) => ({ client_id: v.clientId.trim(), link: v.link.trim(), api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="esign-upload-pdf-via-link"
        submitLabel="Upload PDF"
        successSummary="PDF uploaded"
        errorSummary="Upload failed"
        confirmHeader="Confirm PDF upload"
        confirmAcceptLabel="Yes, upload"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'E-Sign PDF Uploaded', icon: 'pi-cloud-upload' }}
    />
);

export default EsignUploadPdfViaLinkInputComponent;
